export function stripObjectByKeys<T>(object: Object, keys: Array<string>): T {
    const newObject: any = {};

    return Object.keys(object)
        .filter(key => {
            return keys.indexOf(key) >= 0;
        })
        .reduce<T>((accumulator, key) => {
            accumulator[key] = object[key];
            return accumulator;
        }, newObject);
}


// WEBPACK FOOTER //
// ./libs/chassis-resource/src/utils/pure-functions.ts